var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.917 23.148C10.0073 23.148 9.13817 22.7809 7.39995 22.0466C3.07315 20.2189 0.909752 19.305 0.909752 17.7678C0.909752 17.3374 0.909752 9.87674 0.909752 6.46924M10.917 23.148C11.8268 23.148 12.6959 22.7809 14.4341 22.0466C18.7609 20.2189 20.9243 19.305 20.9243 17.7678V6.46924M10.917 23.148L10.917 11.3115",
    stroke: "#DC2626",
    strokeWidth: 1.81951,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83175 9.46187L3.5836 7.89013C1.80104 7.02757 0.909752 6.59628 0.909752 5.91331C0.909752 5.23033 1.80104 4.79905 3.5836 3.93649L6.83175 2.36475C8.83645 1.39469 9.8388 0.909668 10.917 0.909668C11.9953 0.909668 12.9976 1.39469 15.0023 2.36474L18.2505 3.93648C20.033 4.79905 20.9243 5.23033 20.9243 5.91331C20.9243 6.59628 20.033 7.02757 18.2505 7.89013L15.0023 9.46187C12.9976 10.4319 11.9953 10.9169 10.917 10.9169C9.8388 10.9169 8.83645 10.4319 6.83175 9.46187Z",
    stroke: "#DC2626",
    strokeWidth: 1.81951,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24551 12.0288L6.46935 13.1407",
    stroke: "#DC2626",
    strokeWidth: 1.81951,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4766 3.1333L5.35743 8.6929",
    stroke: "#DC2626",
    strokeWidth: 1.81951,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.e483600f176f238d303c69924c06dba9.svg";
export { ForwardRef as ReactComponent };